import { render } from "./user-no-avatar.svg?vue&type=template&id=90dcdfea"
const script = {}
script.render = render

export default script